import { ISearchAddress } from '@agco-onedigital/ecosystem-lib-frontend-utils';

export const mockAddressSuggestions: ISearchAddress[] = [
  {
    id: '32a987ce-55ef-4745-ba55-eaa9d9ed06e3',
    street: '935 MCCALLIE LOOP',
    city: 'CARLISLE',
    country: 'United States',
    zipCode: '72024-9052',
    state: 'Arkansas',
  },
  {
    id: 'ec0cd849-59fe-4164-aa58-92c5234aaa2f',
    street: '935 MCCALLIE AVE',
    city: 'CHATTANOOGA',
    country: 'United States',
    zipCode: '37403-2725',
    state: 'Tennessee',
  },
];
